// extracted by mini-css-extract-plugin
export default {"btn":"Chat_btn__qBvb3","Mobbtn":"Chat_Mobbtn__O9l7A","Mobicon":"Chat_Mobicon__piBmP","icon":"Chat_icon__hdCY1","Tabbtn":"Chat_Tabbtn__krNFp","Tabicon":"Chat_Tabicon__2Xmgk"};